/**
 * 视口尺寸：与 Chrome / Safari 的 layout viewport 对齐，优先使用 Visual Viewport API（移动端地址栏、键盘、缩放时更准确）。
 */

export function getLayoutViewportWidth(): number {
  if (typeof window === 'undefined') {
    return 1024;
  }
  return window.visualViewport?.width ?? window.innerWidth;
}

export function getLayoutViewportHeight(): number {
  if (typeof window === 'undefined') {
    return 768;
  }
  return window.visualViewport?.height ?? window.innerHeight;
}
